import gql from 'graphql-tag';

import A_LETTERS_KPM_ACTIVITY_FRAGMENT from '../fragments/ALettersKpmActivity';
import A_PARAGRAPH_WPM_ACTIVITY_FRAGMENT from '../fragments/AParagraphWpmActivity';
import A_SENTENCES_WPM_ACTIVITY_FRAGMENT from '../fragments/ASentencesWpmActvity';
import A_WORDS_WPM_ACTIVITY_FRAGMENT from '../fragments/AWordsWpmActivity';
import BEGINNING_LETTER_ACTIVITY_FRAGMENT from '../fragments/BeginningLetterActivity';
import BUILD_A_KEYBOARD_ACTIVITY_FRAGMENT from '../fragments/BuildAKeyboardActivity';
import BUILD_A_SENTENCE_ACTIVITY_FRAGMENT from '../fragments/BuildASentenceActivity';
import CONCENTRATION_ACTIVITY_FRAGMENT from '../fragments/ConcentrationActivity';
import CONSTRUCT_A_RESPONSE_ACTIVITY_FRAGMENT from '../fragments/ConstructAResponseActivity';
import CURTAIN_CALL_ACTIVITY_FRAGMENT from '../fragments/CurtainCallActivity';
import DOLCH_DYNAMITE_ACTIVITY_FRAGMENT from '../fragments/DolchDynamiteActivity';
import DOLCH_SPACE_ACTIVITY_FRAGMENT from '../fragments/DolchSpaceActivity';
import DRAG_AND_DROP_ACTIVITY_FRAGMENT from '../fragments/DragAndDropActivity';
import DUMP_THE_COMBO_ACTIVITY_FRAGMENT from '../fragments/DumpTheComboActivity';
import EQUATION_BUILDER_ACTIVITY_FRAGMENT from '../fragments/EquationBuilderActivity';
import FACE_FLIP_ACTIVITY_FRAGMENT from '../fragments/FaceFlipActivity';
import FANCY_FORMATTING_ACTIVITY_FRAGMENT from '../fragments/FancyFormattingActivity';
import FILL_BLANK_SENTENCES_ACTIVITY_FRAGMENT from '../fragments/FillBlankSentencesActivity';
import FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT from '../fragments/FillInTheBlanksActivity';
import FIND_THE_LETTER_ACTIVITY_FRAGMENT from '../fragments/FindTheLetterActivity';
import GRAPH_IT_ACTIVITY_FRAGMENT from '../fragments/GraphItActivity';
import HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT from '../fragments/HearItTypeItActivity';
import HIGHLIGHT_IT_ACTIVITY_FRAGMENT from '../fragments/HighlightItActivity';
import HOMONYM_ACTIVITY_FRAGMENT from '../fragments/HomonymActivity';
import I_KEYBOARDING_ACTIVITY_FRAGMENT from '../fragments/Activity';
import I_KEYBOARDING_ACTIVITY_KEYBOARD_FRAGMENT from '../fragments/KeyboardActivity';
import I_KEYBOARDING_AFFIRMATION_FRAGMENT from '../fragments/Affirmation';
import I_KEYBOARDING_SCHEDULED_ACTIVITY_FRAGMENT from '../fragments/ScheduledActivity';
import LABEL_MAKER_ACTIVITY_FRAGMENT from '../fragments/LabelMakerActivity';
import LEFT_IMAGE_PARAGRAPH_ACTIVITY_FRAGMENT from '../fragments/LeftImageParagraphActivity';
import LEFT_IMAGE_SENTENCES_ACTIVITY_FRAGMENT from '../fragments/LeftImageSentencesActivity';
import LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT from '../fragments/LeftRightPanelRevealActivity';
import MAT_MAN_MATCH_ACTIVITY_FRAGMENT from '../fragments/MatManMatchActivity';
import MAT_MAN_MATCH_ASSESSMENT_FRAGMENT from '../fragments/MatManMatchAssessment';
import MATH_MASTER_ACTIVITY_FRAGMENT from '../fragments/MathMasterActivity';
import MATH_SENTENCES_ACTIVITY_FRAGMENT from '../fragments/MathSentencesActivity';
import MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT from '../fragments/MrsNewsSyllables';
import MULTIPART_ACTIVITY_FRAGMENT from '../fragments/MultiPartActivity';
import MULTISELECT_ACTIVITY_FRAGMENT from '../fragments/MultiSelectActivity';
import I_KEYBOARDING_ACTIVITY_INSTRUCTIONS_FRAGMENT from '../fragments/IKeyboardingActivityInstructions';
import MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT from '../fragments/MusiciansOnStageActivity';
import MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT from '../fragments/MyChoiceKeyboardingActivity';
import NOT_THE_SAME_ACTIVITY_FRAGMENT from '../fragments/NotTheSameActivity';
import OBJECT_IN_A_SENTENCE_ACTIVITY_FRAGMENT from '../fragments/ObjectInASentenceActivity';
import OBJECT_SHUFFLE_ACTIVITY_FRAGMENT from '../fragments/ObjectShuffleActivity';
import ONE_AND_MORE_ACTIVITY_FRAGMENT from '../fragments/OneAndMoreActivity';
import PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT from '../fragments/PaintedFingerClueActivity';
import PARAGRAPH_CENTERED_ACTIVITY_FRAGMENT from '../fragments/ParagraphCenteredActivity';
import PICK_THE_ANSWER_ACTIVITY_FRAGMENT from '../fragments/PickTheAnswerActivity';
import PUZZLE_PIECES_ACTIVITY_FRAGMENT from '../fragments/PuzzlePiecesActivity';
import PUZZLING_LETTERS_ACTIVITY_FRAGMENT from '../fragments/PuzzlingLettersActivity';
import Q_AND_A_ACTIVITY_FRAGMENT from '../fragments/QAndAActivity';
import QUOTE_BUBBLE_ACTIVITY_FRAGMENT from '../fragments/QuoteBubbleActivity';
import QUOTE_BUBBLE_2_ACTIVITY_FRAGMENT from '../fragments/QuoteBubble2Activity';
import RHYME_FLIP_ACTIVITY_FRAGMENT from '../fragments/RhymeFlipActivity';
import RHYMES_WITH_ACTIVITY_FRAGMENT from '../fragments/RhymesWithActivity';
import SCROLLED_SECRETS_ACTIVITY_FRAGMENT from '../fragments/ScrolledSecretsActivity';
import SELECT_IT_ACTIVITY_FRAGMENT from '../fragments/SelectItActivity';
import SENTENCES_DOCTOR_ACTIVITY_FRAGMENT from '../fragments/SentenceDoctorActivity';
import SHIFT_FOR_CAPITALS_ACTIVITY_FRAGMENT from '../fragments/ShiftForCapitalsActivity';
import SHIFTY_TARGETS_ACTIVITY_FRAGMENT from '../fragments/ShiftyTargetsActivity';
import SPACEBAR_ACTIVITY_FRAGMENT from '../fragments/SpacebarActivity';
import STARTS_WITH_ACTIVITY_FRAGMENT from '../fragments/StartsWithActivity';
import STOP_DROP_AND_TYPE_ACTIVITY_FRAGMENT from '../fragments/StopDropAndTypeActivity';
import TAB_YOURE_IT_ACTIVITY_FRAGMENT from '../fragments/TabYoureItActivity';
import TARGET_PRACTICE_ACTIVITY_FRAGMENT from '../fragments/TargetPracticeActivity';
import TEACHER_CREATION_ACTIVITY_FRAGMENT from '../fragments/TeacherCreationActivity';
import TOP_BOTTOM_PANEL_REVEAL_ACTIVITY_FRAGMENT from '../fragments/TopBottomPanelRevealActivity';
import VENN_DIAGRAM_ACTIVITY_FRAGMENT from '../fragments/VennDiagramActivity';
import VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT from '../fragments/VowelComboLaunchActivity';
import WHACK_A_MOLE_ACTIVITY_FRAGMENT from '../fragments/WhackAMoleActivity';
import WOOD_PIECES_ACTIVITY_FRAGMENT from '../fragments/WoodPiecesActivity';

const ACTIVITY_QUERY = gql`
  query keyboardingActivityPreview($where: KeyboardingActivityPreviewWhereInput!) {
    keyboardingActivityPreview(where: $where) {
      ...IKeyboardingActivityFragment
      ...IKeyboardingAffirmationFragment
      ...IKeyboardingActivityKeyboardFragment
      ...IKeyboardingActivityInstructionsFragment
      ...IKeyboardingScheduledActivityFragment
      ...ALettersKpmActivityFragment
      ...AParagraphWpmActivityFragment
      ...ASentencesWpmActivityFragment
      ...AWordsWpmActivityFragment
      ...BeginningLetterActivityFragment
      ...BuildAKeyboardActivityFragment
      ...BuildASentenceActivityFragment
      ...ConcentrationActivityFragment
      ...ConstructAResponseActivityFragment
      ...CurtainCallActivityFragment
      ...DolchDynamiteActivityFragment
      ...DolchSpaceActivityFragment
      ...DragAndDropActivityFragment
      ...DumpTheComboActivityFragment
      ...EquationBuilderActivityFragment
      ...FaceFlipActivityFragment
      ...FancyFormattingActivityFragment
      ...FillBlankSentencesActivityFragment
      ...FillInTheBlanksActivityFragment
      ...FindTheLetterActivityFragment
      ...GraphItActivityFragment
      ...HearItTypeItActivityFragment
      ...HighlightItActivityFragment
      ...HomonymActivityFragment
      ...LabelMakerActivityFragment
      ...LeftImageParagraphActivityFragment
      ...LeftImageSentencesActivityFragment
      ...LeftRightPanelRevealActivityFragment
      ...MathMasterActivityFragment
      ...MathSentencesActivityFragment
      ...MatManMatchActivityFragment
      ...MatManMatchAssessmentFragment
      ...MrsNewsSyllablesActivityFragment
      ...MultiPartActivityFragment
      ...MultiSelectActivityFragment
      ...MusiciansOnStageActivityFragment
      ...MyChoiceKeyboardingActivityFragment
      ...NotTheSameActivityFragment
      ...ObjectInASentenceActivityFragment
      ...ObjectShuffleActivityFragment
      ...OneAndMoreActivityFragment
      ...PaintedFingerClueActivityFragment
      ...ParagraphCenteredActivityFragment
      ...PickTheAnswerActivityFragment
      ...PuzzlePiecesActivityFragment
      ...PuzzlingLettersActivityFragment
      ...QandAActivityFragment
      ...QuoteBubbleActivityFragment
      ...QuoteBubble2ActivityFragment
      ...RhymeFlipActivityFragment
      ...RhymesWithActivityFragment
      ...ScrolledSecretsActivityFragment
      ...SelectItActivityFragment
      ...SentenceDoctorActivityFragment
      ...ShiftForCapitalsActivityFragment
      ...StartsWithActivityFragment
      ...StopDropAndTypeActivityFragment
      ...ShiftyTargetsActivityFragment
      ...SpacebarActivityFragment
      ...StartsWithActivityFragment
      ...TabYoureItActivityFragment
      ...TargetPracticeActivityFragment
      ...TeacherCreationActivityFragment
      ...TopBottomPanelRevealActivityFragment
      ...VennDiagramActivityFragment
      ...VowelComboLaunchActivityFragment
      ...WhackAMoleActivityFragment
      ...WoodPiecesActivityFragment
    }
  }
  ${I_KEYBOARDING_ACTIVITY_FRAGMENT}
  ${I_KEYBOARDING_ACTIVITY_KEYBOARD_FRAGMENT}
  ${I_KEYBOARDING_AFFIRMATION_FRAGMENT}
  ${I_KEYBOARDING_ACTIVITY_INSTRUCTIONS_FRAGMENT}
  ${I_KEYBOARDING_SCHEDULED_ACTIVITY_FRAGMENT}
  ${A_LETTERS_KPM_ACTIVITY_FRAGMENT}
  ${A_PARAGRAPH_WPM_ACTIVITY_FRAGMENT}
  ${A_SENTENCES_WPM_ACTIVITY_FRAGMENT}
  ${A_WORDS_WPM_ACTIVITY_FRAGMENT}
  ${BEGINNING_LETTER_ACTIVITY_FRAGMENT}
  ${BUILD_A_KEYBOARD_ACTIVITY_FRAGMENT}
  ${BUILD_A_SENTENCE_ACTIVITY_FRAGMENT}
  ${CONCENTRATION_ACTIVITY_FRAGMENT}
  ${CONSTRUCT_A_RESPONSE_ACTIVITY_FRAGMENT}
  ${CURTAIN_CALL_ACTIVITY_FRAGMENT}
  ${DOLCH_DYNAMITE_ACTIVITY_FRAGMENT}
  ${DOLCH_SPACE_ACTIVITY_FRAGMENT}
  ${DRAG_AND_DROP_ACTIVITY_FRAGMENT}
  ${DUMP_THE_COMBO_ACTIVITY_FRAGMENT}
  ${EQUATION_BUILDER_ACTIVITY_FRAGMENT}
  ${FACE_FLIP_ACTIVITY_FRAGMENT}
  ${FANCY_FORMATTING_ACTIVITY_FRAGMENT}
  ${FACE_FLIP_ACTIVITY_FRAGMENT}
  ${FILL_BLANK_SENTENCES_ACTIVITY_FRAGMENT}
  ${FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT}
  ${FIND_THE_LETTER_ACTIVITY_FRAGMENT}
  ${GRAPH_IT_ACTIVITY_FRAGMENT}
  ${HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT}
  ${HIGHLIGHT_IT_ACTIVITY_FRAGMENT}
  ${HOMONYM_ACTIVITY_FRAGMENT}
  ${LABEL_MAKER_ACTIVITY_FRAGMENT}
  ${LEFT_IMAGE_PARAGRAPH_ACTIVITY_FRAGMENT}
  ${LEFT_IMAGE_SENTENCES_ACTIVITY_FRAGMENT}
  ${LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT}
  ${MATH_MASTER_ACTIVITY_FRAGMENT}
  ${MATH_SENTENCES_ACTIVITY_FRAGMENT}
  ${MAT_MAN_MATCH_ACTIVITY_FRAGMENT}
  ${MAT_MAN_MATCH_ASSESSMENT_FRAGMENT}
  ${MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT}
  ${MULTIPART_ACTIVITY_FRAGMENT}
  ${MULTISELECT_ACTIVITY_FRAGMENT}
  ${MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT}
  ${MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT}
  ${NOT_THE_SAME_ACTIVITY_FRAGMENT}
  ${OBJECT_IN_A_SENTENCE_ACTIVITY_FRAGMENT}
  ${OBJECT_SHUFFLE_ACTIVITY_FRAGMENT}
  ${ONE_AND_MORE_ACTIVITY_FRAGMENT}
  ${PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT}
  ${PARAGRAPH_CENTERED_ACTIVITY_FRAGMENT}
  ${PICK_THE_ANSWER_ACTIVITY_FRAGMENT}
  ${PUZZLE_PIECES_ACTIVITY_FRAGMENT}
  ${PUZZLING_LETTERS_ACTIVITY_FRAGMENT}
  ${Q_AND_A_ACTIVITY_FRAGMENT}
  ${QUOTE_BUBBLE_ACTIVITY_FRAGMENT}
  ${QUOTE_BUBBLE_2_ACTIVITY_FRAGMENT}
  ${RHYME_FLIP_ACTIVITY_FRAGMENT}
  ${RHYMES_WITH_ACTIVITY_FRAGMENT}
  ${SCROLLED_SECRETS_ACTIVITY_FRAGMENT}
  ${SELECT_IT_ACTIVITY_FRAGMENT}
  ${SENTENCES_DOCTOR_ACTIVITY_FRAGMENT}
  ${SHIFT_FOR_CAPITALS_ACTIVITY_FRAGMENT}
  ${SHIFTY_TARGETS_ACTIVITY_FRAGMENT}
  ${STARTS_WITH_ACTIVITY_FRAGMENT}
  ${STOP_DROP_AND_TYPE_ACTIVITY_FRAGMENT}
  ${SPACEBAR_ACTIVITY_FRAGMENT}
  ${TAB_YOURE_IT_ACTIVITY_FRAGMENT}
  ${TARGET_PRACTICE_ACTIVITY_FRAGMENT}
  ${TEACHER_CREATION_ACTIVITY_FRAGMENT}
  ${TOP_BOTTOM_PANEL_REVEAL_ACTIVITY_FRAGMENT}
  ${VENN_DIAGRAM_ACTIVITY_FRAGMENT}
  ${VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT}
  ${WHACK_A_MOLE_ACTIVITY_FRAGMENT}
  ${WOOD_PIECES_ACTIVITY_FRAGMENT}
`;

export default ACTIVITY_QUERY;
